module.exports = __webpack_public_path__ + "static/DY0-55efa91a34175154688a99c9edc9f755.jpg";